import React from 'react'
import "./Ultimatecourse.css";
import backgrouncourse from "../images/png/Rectangle217.png";
import camera from '../images/png/image183.png';

const Ultimatecourse=()=>{
  return (
    <div>
        <div className='ultimate'style={{backgroundImage:`url(${backgrouncourse})`}}>
            <div className='photo'>
                <p>ULTIMATE <br/>COURSE IN</p>
                <h1>PHOTOGRAPHY</h1>
            </div>
            <div className='imgcourse'>
                 <img src={camera} alt="err"/>
            </div>
        </div>
    </div>
  )
}
export {Ultimatecourse}
